import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Função para inicializar o app de forma segura
const initializeApp = () => {
  try {
    const root = document.getElementById('root');

    if (!root) {
      console.error('Root element not found');
      // Cria o elemento root se não existir
      const newRoot = document.createElement('div');
      newRoot.id = 'root';
      document.body.appendChild(newRoot);
      return newRoot;
    }

    return root;
  } catch (error) {
    console.error('Erro ao inicializar root:', error);
    // Fallback: cria elemento root
    const fallbackRoot = document.createElement('div');
    fallbackRoot.id = 'root';
    document.body.appendChild(fallbackRoot);
    return fallbackRoot;
  }
};

// Aguarda o DOM estar pronto
const startApp = () => {
  try {
    const rootElement = initializeApp();
    
    // Renderiza o app de forma mais robusta
    createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Erro ao renderizar app:', error);
    // Fallback básico
    document.body.innerHTML = '<div style="padding: 20px; text-align: center;">Carregando aplicativo...</div>';
    // Tenta novamente após um delay
    setTimeout(startApp, 1000);
  }
};

// Verifica se o DOM já está carregado
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startApp);
} else {
  startApp();
}

// Registra o service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silently fail
    });
  });
}
